module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/841a85ee6d1c7e2574d87175354b0321.svg";